import React from 'react';
import { Typography } from '@fortress-technology-solutions/fortress-component-library/Atoms';
import { Modal } from '@fortress-technology-solutions/fortress-component-library/Molecules_Fortress';
import { PeopleIcon } from '@fortress-technology-solutions/fortress-component-library/Icons';
import messages from './messages';

type Props = {
  open: boolean,
  onClose: () => void,
  onConfirm: () => void,
  intl: Object,
};

const ConfirmRemovalModal = ({ open, onClose, onConfirm, intl }: Props) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      title={intl.formatMessage(messages.removeFromQueueTitle)}
      icon={<PeopleIcon />}
      actionsProps={[
        {
          children: intl.formatMessage(messages.cancelButton),
          variant: 'text',
          onClick: onClose,
        },
        {
          children: intl.formatMessage(messages.confirmButton),
          onClick: onConfirm,
          color: 'error',
        },
      ]}
      ModalProps={{
        PaperProps: {
          sx: {
            maxWidth: 400,
          },
        },
      }}
    >
      <Typography
        variant="bodyMedium"
        dangerouslySetInnerHTML={{
          __html: intl.formatMessage(messages.confirmRemovalMessage),
        }}
      />
    </Modal>
  );
};

export default ConfirmRemovalModal;
